/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import Draggable from 'react-draggable';
import {
  UpTriangleSmall,
  DownTriangleSmall,
  Cross,
  HomeLine,
  BackThick,
  Info,
} from 'sushiweb/Icons';
import black from 'sushiweb/tokens/color/black';
import { Tooltip } from '../../UiKit';
import NodesList from './NodesList';
import { useMutationCall } from '../../api/react-client';
import SearchWithFilters from './SearchWithFilters';
import {
  helpDeskClosedEvent,
  helpDeskCollapsedEvent,
  helpDeskExpandedEvent,
  helpDeskHomeClickEvent,
} from '../../analytics/events';
import { MetricsForJumboEvent } from '../../analytics/constants';

const FEATURE_ENABLED = 'enabled';

const HelpDeskV2 = ({ setOpenHelpSection, orderId, defaultOpen = false }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [clickedToHome, setClickedToHome] = useState(false);
  const [showBack, setShowBack] = useState(false);
  const [callBack, setCallBack] = useState(false);
  const [allData, setAllData] = useState();
  const [nodesToRender, setNodesToRender] = useState([]);
  const [magnify, setMagnify] = useState(FEATURE_ENABLED);
  const [context, setContext] = useState(FEATURE_ENABLED);
  const [nodesFetching, setNodesFetching] = useState();
  const fetch_nodes_endpoint = `helpdesk/fetch_help_nodes`;

  const {
    mutate: searchNodes,
    isLoading: nodesLoading,
    data: nodesList,
  } = useMutationCall({}, fetch_nodes_endpoint, [], {
    doNotShowSuccessToast: true,
  });

  useEffect(() => {
    searchNodes({
      order_id: orderId,
      magnify: magnify,
      context: context,
    });
  }, []);

  useEffect(() => {
    if (clickedToHome)
      searchNodes({
        order_id: orderId,
        magnify: magnify,
        context: context,
      });
  }, [clickedToHome]);

  useEffect(() => {
    setAllData(nodesList);
    setNodesToRender(nodesList);
  }, [nodesList, setAllData, setNodesToRender]);

  const closeHelpSectionHandler = useCallback(() => {
    setOpenHelpSection(false);
    helpDeskClosedEvent({
      [MetricsForJumboEvent.order_id]: orderId,
    });
  }, [setOpenHelpSection]);

  const handleExpansion = useCallback(() => {
    setIsExpanded((prevState) => !prevState);
  }, []);

  const resetNodes = useCallback(() => {
    setClickedToHome(true);
    setMagnify(FEATURE_ENABLED);
    setContext(FEATURE_ENABLED);
    helpDeskHomeClickEvent({
      [MetricsForJumboEvent.order_id]: orderId,
    });
  }, []);

  const backArrowHandler = useCallback(() => {
    setCallBack(true);
  }, []);

  if (!nodesList?.length && defaultOpen) return null;

  return (
    <Draggable bounds='parent' enableUserSelectHack={false} cancel='p'>
      <div
        className={`tw-bg-indigo-100 tw-fixed tw-right-1 tw-bottom-1 tw-flex-col tw-rounded-2xl tw-cursor-pointer tw-max-h-[70%] tw-w-[36rem]`}
        css={`
          z-index: 20;
          box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
        `}
        id='drragable_helpdesk'
      >
        <div className='tw-flex tw-justify-between tw-mx-6 tw-mt-6 tw-mb-5'>
          <div className='tw-flex tw-gap-3'>
            {showBack && <BackThick size={14} onClick={backArrowHandler} />}
            <span className='tw-text-500 tw-font-bold tw-flex tw-gap-3'>
              <span> How can I help you?</span>
              <Tooltip
                position='top'
                border={false}
                title={<Info size={14} color={black} />}
                label={() => {
                  return (
                    <div className='tw-text-100 tw-font-medium'>
                      <strong>OrderId</strong>: {orderId}
                    </div>
                  );
                }}
              />
            </span>
          </div>
          <div className='tw-flex tw-gap-3'>
            <HomeLine size={20} color={black} onClick={resetNodes} />
            <span onClick={handleExpansion}>
              {isExpanded ? (
                <DownTriangleSmall
                  size={20}
                  color={black}
                  onClick={() => {
                    helpDeskCollapsedEvent({
                      [MetricsForJumboEvent.order_id]: orderId,
                    });
                  }}
                />
              ) : (
                <UpTriangleSmall
                  size={20}
                  color={black}
                  onClick={() => {
                    helpDeskExpandedEvent({
                      [MetricsForJumboEvent.order_id]: orderId,
                    });
                  }}
                />
              )}
            </span>

            <Cross
              size={20}
              color={black}
              onClick={closeHelpSectionHandler}
              className='tw-cursor-pointer'
            />
          </div>
        </div>

        {isExpanded && (
          <>
            <div className='tw-px-6 tw-pb-6 tw-shadow-[0_5px_16px_0_rgba(0,0,0,0.08)] '>
              <SearchWithFilters
                orderId={orderId}
                searchData={allData}
                setSearchResults={setNodesToRender}
                setClickedToHome={setClickedToHome}
                setNodesFetching={setNodesFetching}
              />
            </div>
            <div className={`tw-flex-col tw-gap-4 tw-overflow-y-auto `}>
              <NodesList
                allData={allData}
                showGuideLineOpened={magnify && context}
                nodesToRender={nodesToRender}
                orderId={orderId}
                clickedToHome={clickedToHome}
                setClickedToHome={setClickedToHome}
                setShowBack={setShowBack}
                callBack={callBack}
                setCallBack={setCallBack}
                setAllData={setAllData}
                nodesLoading={nodesLoading || nodesFetching}
                setNodesToRender={setNodesToRender}
              />
            </div>
          </>
        )}
      </div>
    </Draggable>
  );
};

export default HelpDeskV2;
